import React from "react";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

const CopyRightText = (props) => {
  const { t } = useTranslation();
  return (
      <div>
      {t("copyright_text")}
      </div>
  );
}

export default CopyRightText;
